export default {
  filters: {
    next: 'Dalej',
    back: 'Powrót',
    smartMatchingTitle: 'Smart Matching',
    smartMatchingDescription: 'Narzędzie, dzięki któremu w czasie rzeczywistym znajdziesz najbardziej dopasowane rozwiązania wykorzystujące techniki upcyklingu dla wskazanego przez Ciebie materiału odpadowego. Smart-matching znacząco ułatwia współpracę i produkcję w ramach gospodarki cyrkularnej.',
    material: 'Materiały',
    materials: 'Rodzaje odpadu:',
    materialsDescription: 'Wybierz materiał',
    categories: 'Typ produktu:',
    categoriesDescription: 'Wybierz produkt',
    location: 'Lokalizacja:',
    locationLabel: 'Zacznij pisać aby znaleźć lokalizację.',
    radius: 'Promień (km)',
    advancedFiltersButton: 'Zaawansowane filtry',
    showTourGuide: 'Pokaż samouczek',
  },
  filtersHeader: {
    chosenFilters: 'Wybrane filtry:',
    location: 'lokalizacja: {location}',
    price: 'cena: {price}',
    radius: 'promień: {radius}',
    clearFilters: 'Wyczyść wszystko',
  },
  products: {
    noProducts: 'Nie znaleźliśmy produktów. Proszę {contact}',
    contactUs: 'Skontaktuj się z nami',
  },
  guideModal: {
    firstStep: {
      areYouReady: 'Jesteś gotowy?',
      contactUs: 'ZAPOZNAJ SIĘ Z WYJĄTKOWYMI MOŻLIWOŚCIAMI PRZETWARZANIA ODPADÓW W ESTETYCZNE PRODUKTY WYKONYWANE PRZEZ NAJLEPSZYCH EKO-PROJEKTANTÓW ',
      useSmartMatching: 'WYKORZYSTAJ NASZĄ UNIKALNĄ WYSZUKIWARKĘ  “SMART MATCHING” I ZNAJDŹ W KILKU PROSTYCH KROKACH PRODUKT UPCYKLINGOWY ODPOWIADAJĄCY TWOIM POTRZEBOM',
      start: 'Rozpocznij',
      hideForever: 'Nie pokazuj tego samouczka ponownie',
    },
    secondStep: {
      chooseTheWasteMaterial: 'KROK NR 1: WYBIERZ RODZAJ MATERIAŁU',
      description: 'Wybierz rodzaj materiału odpadowego, który chcesz poddać upcyklingowi.',
      next: 'Dalej',
    },
    thirdStep: {
      chooseTypeOfProduct: 'KROK NR 2: WYBIERZ RODZAJ PRODUKTU',
      description: 'Wybierz rodzaj produktu, który chcesz uzyskać w procesie upcyklingu.',
      showResults: 'POKAŻ WYNIKI',
    },
  },
};
